export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";